import React from 'react'

export default function PopUpBox(props) {
    // const [open, setOpen] = useState(true)
  return (
    <div className={props.open? 'popUpBoxCon': 'none'} onClick={()=>props.setOpen(false)}>
        <div className='popUpBox'>
            <p>{props.content}</p>
        </div>
    </div>
  )
}
